import _ from 'lodash';

const preDesignedApplications = {
  LANDING_PAGE:      'landing-page',
  POPUP_SIGNUP_FORM: 'popup-signup-form',
  SPIN_THE_WHEEL:    'spin-the-wheel',
  CONTENT_CAROUSEL:  'content-carousel',
};

preDesignedApplications.ALL = _.values(preDesignedApplications);

export default preDesignedApplications;
